import { Component, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { EvsProductService } from '../../../../../common/services/EvsProduct.service';
import { ImageService } from '../../../../imageService';
import { AuthBusinessService } from '../../../../../common/services/AuthBusiness.service';
import { ActiveTempNewService } from './services/ActiveTempNew.service';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { environment } from '../../../../../../environments/environment';
import { UploadService } from '../../../../../common/services/Upload.service';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { IOption } from 'ng-select';
import { BatchService } from '../../batchstamp/batch.service';

declare var $: any;

declare function baseTracking(appId);

declare function enterScreenView(
  screenName: any,
  contentType: any,
  referrer: any
);

declare function visibleContent(regionName: any, contentName: any, index: any);

declare function clickTracking(
  regionName: any,
  contentName: any,
  target: any,
  payload: any
);

declare function alertMsg(alertType: any, alertMessage: any);

declare function searchEvent(keywords: any, params: any, order: any, sort: any);

let that: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-activeTempNew',
  templateUrl: './ActiveTempNew.component.html',
  styles: [``],
  styleUrls: ['./ActiveTempNew.component.css'],
  providers: [
    EvsProductService,
    ImageService,
    AuthBusinessService,
    ActiveTempNewService,
  ],
})
// tslint:disable-next-line:component-class-suffix
export class ActiveTempNew implements OnInit, OnDestroy {
  @Output() loadDataParent = new EventEmitter();
  @ViewChild('editStamp') editStamp: ModalDirective;
  @ViewChild('editStampTab3') editStampTab3: ModalDirective;
  @ViewChild('confirmUpload') confirmUpload: ModalDirective;
  @Output('hideCrating') hideCrating = new EventEmitter();
  @Input() batch_detail: any = {};
  z;
  // @ViewChild('itemProduct') itemProduct;
  step = 1;
  // title = 'KÍCH HOẠT VÀ GÁN SẢN PHẨM';
  title = '';
  prefix = '';
  start = '';
  end = '';
  activeTab = 1;
  activeTab3 = 1;
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  public user: any;
  listItem = [];
  listItemTab1 = [];
  listItemTab2 = [];
  boxItem = [];
  listImageDistribution: any = [];
  produce_time: any = '';
  batch_product_number_2: any = '';
  batch_product_number_3: any = '';
  batch_order_code: any = '';
  batch_order_code_2: any = '';
  guarantee_days_update: any = '';
  guarantee_days_max_update: any = '';
  type_guarantee_day: any = 'months';
  type_guarantee_day_max: any = 'months';

  /** Gộp hai button kích hoạt */

  public message: any = { class: '', content: '' };
  configModeTab2: string = 'global';
  public FormActiveStamp: FormGroup;
  is_loading = false;
  list_product: Array<IOption> = [];
  has_product: Boolean = false;
  isManufacturer = '1';
  active_child: Boolean = false;
  is_disable_mekongas: Boolean = true;
  is_check_batch_number: Boolean = false;
  has_child: Boolean = false;
  active_left: number;

  public no_exist_on_seller = false;
  public choice_product: any;
  /* Tuanba:12/4/2022: Mekongas*/
  source = Number(JSON.parse(localStorage.getItem('User')).source);
  activeTabBatch = 0;
  activeUpload = 0;
  public titleFile = 'Chọn file upload';
  public data_import_success: { class: string; content: string; } = null;
  public data_import_fail: { class: string; content: string; } = null;
  public files: any = null;
  public isFormSubmitted = false;
  uploadExcel: any = {};
  
  is_override_warranty_tab1: boolean = false;
  is_override_warranty_tab2: boolean = false;
  cachedReminderConfig: any = null;

  // Biến standalone warranty reminder Tab 2 (bind trực tiếp trong HTML)
  is_maintenance_reminder_tab2: boolean = false;
  maintenance_mode_tab2: string = 'once';
  maintenance_cycle_tab2: any = null;
  maintenance_cycle_unit_tab2: string = 'months';
  is_extend_maintenance_tab2: boolean = false;
  extend_limit_tab2: any = null;
  is_expired_reminder_tab2: boolean = false;
  expired_mode_tab2: string = 'once';
  expired_cycle_tab2: any = null;
  expired_cycle_unit_tab2: string = 'months';

  public formTab2: FormGroup;

  public errMsgAlertBoxStamp = '';
  public errorStep1: Boolean = false;
  public errorStampStep1: Boolean = false;
  tempListTemp: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    public addressService: EvsAddressService,
    private activeTempNewService: ActiveTempNewService,
    private upload: UploadService,
    private zone: NgZone,
    private batchService: BatchService,
    private productService: EvsProductService,
    private connectService: AuthBusinessService,
    private translate: TranslateService
  ) {
    that = this;
    this.user = JSON.parse(localStorage.getItem('User'));
    this.initTranslations();
  }

  private initTranslations() {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.title = this.translate.instant('KICH_HOAT_LO_TEM_CAPS');
      this.titleFile = this.translate.instant('CHON_FILE_UPLOAD');
      this.listTime = {
        days: this.translate.instant('NGAY'),
        months: this.translate.instant('THANG'),
        years: this.translate.instant('NAM'),
      };
    });
    this.title = this.translate.instant('KICH_HOAT_LO_TEM_CAPS');
    this.titleFile = this.translate.instant('CHON_FILE_UPLOAD');
  }

  ngOnDestroy() {
    console.log(1111);
  }

  // box
  tempNewBox: any;
  isBlockchainEnabled: boolean = false;

  ngOnInit() {
    console.log(45677);
    console.log('this.detail', this.batch_detail);
    if (this.batch_detail.has_child) {
      this.has_child = true;
      this.active_child = true;
    }

    if (this.batch_detail.status === 1) {
      this.activeTabBatch = 2;
      clickTracking(
        'qcheck_batch_active',
        'stamp_separatee',
        'stamp_separatee_view',
        ''
      );
    } else {
      this.activeTabBatch = 1;
      clickTracking('qcheck_batch_active', 'stamp_frag', 'stamp_frag_view', '');
    }

    if (this.batch_detail.batch_order_code) {
      this.batch_product_number = this.batch_detail.batch_order_code.slice(-9);
    }
    this.prefix = this.batch_detail ? (this.batch_detail.prefix || '') : '';
    // this.start = this.batch_detail.id_start;
    // this.end = this.batch_detail.id_end;
    this.active_left =
      this.batch_detail.active_left != null
        ? this.batch_detail.active_left
        : this.batch_detail.quantity;
    this.addBoxTemp2();
    // this.addListTemp2();

    $('#produce_time').datepicker({
      format: 'dd/mm/yyyy',
      // "setDate": new Date(),
    });
    // $('#product_id').select2({ placeholder: "-- Chọn sản phẩm --", allowClear: false });
    this.getListProduct();
    this.createForm();
    this.loadBlockchainInfo();

    $('.slt-batchstamp').select2({
      placeholder: 'Chọn lô tem',
      allowClear: true,
      minimumInputLength: 2,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batches`,
        headers: {
          authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 150,
              show_parent_child: 1,
            };
          }
          return {
            offset: 0,
            limit: 150,
            show_parent_child: 1,
          };
        },
        processResults: function (data) {
          console.log('data.data ', data.data);
          console.log('data.data ', data.data);
          return {
            results:
              data.data && data.data.batches
                ? data.data.batches.map((item) => {
                  console.log('tloggggg', {
                    text: item.name,
                    id: `${item.id}+++${item.name}+++${item.prefix}+++${item.id_start}+++${item.id_end}`,
                  });
                  return {
                    text: item.name,
                    id: `${item.id}+++${item.name}+++${item.prefix}+++${item.id_start}+++${item.id_end}`,
                  };
                })
                : [],
          };
        },
      },
    });
  }

  loadBlockchainInfo() {
    this.activeTempNewService.getBlockchainInfo().subscribe(
      (res: any) => {
        this.isBlockchainEnabled = !!(res && res.data && typeof res.data.enableBlockchain !== 'undefined'
          ? res.data.enableBlockchain
          : false);
      },
      () => {
        this.isBlockchainEnabled = false;
      }
    );
  }

  async addNewBox(data?) {
    console.log('news sadboaxxx', this.boxItem)
    this.errorStampStep1 = false;
    const check = this.boxItem.find((element) => element.form.id === data.id);
    console.log('cheacscsck', check)
    if (check) {
      this.toastr.warning(this.translate.instant('LO_TEM_DA_DUOC_CHON'), this.translate.instant('CANH_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    console.log('datadata', data);
    const body = {
      prefix: data.prefix,
      idStart: Number(data.start),
      idEnd: Number(data.end),
    }
    console.log('tuanba-body' + this.batch_detail);
    await this.activeTempNewService.validateStep1(body).subscribe((res) => {
      if (res.code == 1 && res.data.error == true) {
        this.errorStampStep1 = true;
        this.tempNewBox = body
      } else {
        this.tempNewBox = {};
        this.errorStampStep1 = false;
        const item = {
          form: {
            id: data && data.id ? data.id : '',
            name: data && data.name ? data.name : '',
            prefix: data && data.prefix ? data.prefix : '',
            start: data && data.start ? Number(data.start) : '',
            end: data && data.end ? Number(data.end) : '',
            serial: data
              ? `${data.prefix}-${data.start} -> ${data.prefix}-${data.end}`
              : '',
          },
          messageError: {
            id: {
              text: '',
              state: false,
            },
            name: {
              text: '',
              state: false,
            },
            serial: {
              text: '',
              state: false,
            },
          },
        };
        this.boxItem.push(item);
        $('.slt-batchstamp').val('').trigger('change');
      }
    })
    console.log(' this.errorStampStep1' + this.errorStampStep1);
  }

  downloadErrorStamp() {
    this.activeTempNewService.getDownloadExcelError(this.tempNewBox).subscribe((res: any) => {
      this.activeTempNewService.saveToFileSystem(res, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', this.translate.instant('DANH_SACH_LOI_EXCEL'))
    }, (error: any) => {
      this.toastr.error(error.message, this.translate.instant('CANH_BAO'), {
        timeOut: 4000,
        positionClass: 'top-bottom-right'
      })
    })
  }

  removeBox(i) {
    this.boxItem = this.boxItem.filter((res, k) => {
      return i !== k;
    });
  }

  defaultBoxTemp2() {
    this.prefix = this.batch_detail.prefix;
    // this.start = this.batch_detail.id_start;
    // this.end = this.batch_detail.id_end;
  }

  async addBoxTemp2() {
    if (this.batch_detail) {
      console.log('tuanba vao day ko ' + this.batch_detail);
      // const body = {
      //   prefix: this.batch_detail.prefix,
      //   idStart: this.batch_detail.id_start,
      //   idEnd: this.batch_detail.id_end,
      // }
      // console.log('tuanba-body' + this.batch_detail);
      // await this.activeTempNewService.validateStep1(body).subscribe((res) => {
      //   console.log('res', res)
      //   if (res.code == 1 && res.data.error != true) {
      const data_default = {};
      data_default['id'] = this.batch_detail.id;
      data_default['name'] = this.batch_detail.name;
      data_default['prefix'] = this.batch_detail.prefix
      // data_default['start'] = this.batch_detail.id_start;
      // data_default['end'] = this.batch_detail.id_end;
      this.defaultBoxTemp2();
      await this.addNewBox(data_default);
      // }
      // })
    }
  }

  addBoxTemp() {
    this.errorStampStep1 = false;
    if (!$('.slt-batchstamp').val()) {
      this.toastr.warning(this.translate.instant('BAN_CHUA_CHON_LO_TEM'), this.translate.instant('CANH_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    console.log('$(".slt-batchstamp").val()', $('.slt-batchstamp').val());

    const data = {};
    data['id'] = $('.slt-batchstamp').val().split('+++')[0];
    data['name'] = $('.slt-batchstamp').val().split('+++')[1];
    data['prefix'] = $('.slt-batchstamp').val().split('+++')[2];
    data['start'] = $('.slt-batchstamp').val().split('+++')[3];
    data['end'] = $('.slt-batchstamp').val().split('+++')[4];
    this.addNewBox(data);
  }

  // end box

  // list
  addNewList(data?) {
    this.prefix = this.batch_detail ? (this.batch_detail.prefix || '') : '';
    this.start = '';
    this.end = '';
    const item = {
      form: {
        prefix: data && data.prefix ? data.prefix : '',
        start: data && data.start ? data.start : '',
        end: data && data.end ? data.end : '',
        serial: data && data.serial ? data.serial : '',
        productId: null,
        produceTime: null,
        guaranteeDay: null,
        typeGuaranteeDay: 'months',
        guaranteeDayMax: null,
        typeGuaranteeDayMax: 'months',
      },
      messageError: {
        serial: {
          text: '',
          state: false,
        },
      },
    };
    this.listItem.push(item);
  }

  isSubmitEnabled(): boolean {
    return !this.is_loading && this.listItem.length > 0;
  }

  private datePipe: any;

  public errorMessageStep1: string = ''

  addListTemp() {
    this.errorMessageStep1 = ''
    console.log('this.listItem11111', this.listItem[0], this.listItem.length);
    const data = {};
    if (
      (this.start && typeof this.start !== 'number') ||
      (this.end && typeof this.end !== 'number')
    ) {
      this.toastr.warning(this.translate.instant('SERIAL_NHAP_SAI_DINH_DANG'), this.translate.instant('CANH_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    if (!this.prefix || !this.start || !this.end) {
      this.toastr.warning(this.translate.instant('BAN_CHUA_NHAP_SERIAL'), this.translate.instant('CANH_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    if (this.start && this.end && this.start > this.end) {
      this.toastr.warning(this.translate.instant('SERIAL_CUOI_PHAI_LON_HON_SERIAL_DAU'), this.translate.instant('CANH_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    let check = true;
    this.listItem.map((element) => {
      if (element.form.prefix.toUpperCase() === this.prefix.toUpperCase()) {
        if (this.start && this.end) {
          let temp = '';
          if (
            element.form.start &&
            element.form.end &&
            ((this.start >= element.form.start &&
              this.start <= element.form.end) ||
              (this.end <= element.form.end &&
                this.end >= element.form.start) ||
              (this.end >= element.form.end &&
                this.start <= element.form.start))
          ) {
            temp = `${element.form.prefix.toUpperCase()}-${element.form.start
              } -> ${element.form.prefix.toUpperCase()}-${element.form.end}`;
            this.toastr.warning(this.translate.instant('DAI_TEM_TRUNG_VOI_TEM', { value: temp }), this.translate.instant('CANH_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
            check = false;
            return;
          }

          if (
            ((element.form.start && !element.form.end) ||
              (!element.form.start && element.form.end)) &&
            ((element.form.start &&
              this.start <= element.form.start &&
              this.end >= element.form.start) ||
              (element.form.end &&
                this.end >= element.form.end &&
                this.start <= element.form.end))
          ) {
            temp = element.form.start
              ? `${element.form.prefix.toUpperCase()}-${element.form.start}`
              : `${element.form.prefix.toUpperCase()}-${element.form.end}`;
            this.toastr.warning(this.translate.instant('DAI_TEM_TRUNG_VOI_TEM', { value: temp }), this.translate.instant('CANH_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
            check = false;
            return;
          }
        }
        if ((this.start && !this.end) || (this.end && !this.start)) {
          if (
            element.form.start &&
            element.form.end &&
            ((this.start &&
              this.start >= element.form.start &&
              this.start <= element.form.end) ||
              (this.end &&
                this.end <= element.form.end &&
                this.end >= element.form.start))
          ) {
            this.toastr.warning(
              this.translate.instant('TEM_TRUNG_VOI_DAI_TEM', {
                value: `${element.form.prefix.toUpperCase()}-${element.form.start} -> ${element.form.prefix.toUpperCase()}-${element.form.end}`
              }),
              this.translate.instant('CANH_BAO'),
              {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              }
            );
            check = false;
            return;
          }

          if (
            (this.start &&
              (this.start === element.form.end ||
                this.start === element.form.start)) ||
            (this.end &&
              (this.end === element.form.end ||
                this.end === element.form.start))
          ) {
            this.toastr.warning(
              this.translate.instant('TEM_TRUNG_VOI_TEM', {
                value: `${element.form.prefix.toUpperCase()}-${element.form.start ? element.form.start : element.form.end}`
              }),
              this.translate.instant('CANH_BAO'),
              {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              }
            );
            check = false;
            return;
          }
        }
      }
    });
    const dataValidate = {}
    if (check) {
      dataValidate['prefix'] = this.prefix.toUpperCase();
      dataValidate['idStart'] = this.start ? this.start : '';
      dataValidate['idEnd'] = this.end ? this.end : '';
      this.activeTempNewService.validateStep1(dataValidate).subscribe((res: any) => {
        console.log('res2', res)
        if (res.code == 1) {
          if (res.data && !res.data.error) {
            this.errorStep1 = false
            data['prefix'] = this.prefix.toUpperCase();
            data['start'] = this.start || '';
            data['end'] = this.end || '';
            data['serial'] = this.start && this.end && this.start !== this.end
              ? `${data['prefix']}-${this.start} -> ${data['prefix']}-${this.end}`
              : `${data['prefix']}-${this.start || this.end}`;
            this.addNewList(data);
          } else {
            this.tempListTemp = dataValidate;
            this.tempListTemp.type = res.data.type || ''
            this.errorStep1 = true
            this.errorMessageStep1 = res.data.message
            return
          }
        } else {
          console.log('coe 100', res)
          this.tempListTemp = dataValidate;
          this.tempListTemp.type = (res.data && res.data.type) || ''
          this.errorStep1 = false;
          this.toastr.warning(res.message, this.translate.instant('THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        }

        // if (res.data && res.data.error) {
        //   this.errorStep1 = true
        //   data['prefix'] = this.prefix.toUpperCase();
        //   if (
        //     (this.start && !this.end) ||
        //     (this.end && !this.start) ||
        //     this.start === this.end
        //   ) {
        //
        //     data['start'] = this.start ? this.start : '';
        //     data['end'] = this.end ? this.end : '';
        //     data['serial'] = this.start
        //       ? `${this.prefix.toUpperCase()}-${this.start}`
        //       : `${this.prefix.toUpperCase()}-${this.end}`;
        //     this.addNewList(data);
        //     return;
        //   }
        //   console.log('444', data);
        //   data['start'] = this.start;
        //   data['end'] = this.end;
        //   data['serial'] = `${this.prefix.toUpperCase()}-${this.start
        //   } -> ${this.prefix.toUpperCase()}-${this.end}`;
        //   this.addNewList(data);
        // } else {
        //   this.tempListTemp = dataValidate;
        //   this.errorStep1 = false;
        //   this.toastr.warning(res.message, 'Thông báo:', {
        //     timeOut: 3000,
        //     positionClass: 'toast-top-right',
        //   });
        // }

      }, (error: any) => {
        console.log(error, error);
      })
    }
  }

  blobToFile(data: any, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  export(data, nameFile) {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(data);
    link.download = nameFile;
    link.click();
  }

  downloadError() {
    // @ts-ignore
    this.activeTempNewService.getDownloadExcelError(this.tempListTemp).subscribe((res: any) => {
      this.activeTempNewService.saveToFileSystem(res, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', this.translate.instant('DANH_SACH_LOI_EXCEL'))
    }, (error: any) => {
      this.toastr.error(error.message, this.translate.instant('CANH_BAO'), {
        timeOut: 4000,
        positionClass: 'top-bottom-right'
      })
    })
  }

  addListTemp2() {
    if (this.batch_detail) {
      console.log('tuâba' + this.batch_detail);
      const data_default = {};
      data_default['serial'] = this.batch_detail.serial;
      data_default['prefix'] = this.batch_detail.prefix;
      data_default['start'] = this.batch_detail.id_start;
      data_default['end'] = this.batch_detail.id_end;
      this.addNewList(data_default);
    }
  }

  removeList(i) {
    this.listItem = this.listItem.filter((res, k) => {
      return i !== k;
    });
  }

  /*///!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!**!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/*/
  // TAB 2
  serialDetail;
  listTime = {
    days: 'Ngày',
    months: 'Tháng',
    years: 'Năm',
  };

  resetActiveAllTab2() {
    this.produce_time = '';
    this.guarantee_days_update = '';
    this.guarantee_days_max_update = '';
    this.type_guarantee_day = 'months';
    this.type_guarantee_day_max = 'months';
    // this.batch_product_number_2 = '';
    // this.batch_product_number_3 = ''
  }

  showSetting(serial, batchOrderCode, listItemTab2) {
    this.resetActiveAllTab2();
    this.serialDetail = serial;
    console.log('listItemTab2', listItemTab2);
    console.log('listItemTab2', this.produce_time);
    if (listItemTab2.batchProductNumber !== '') {
      this.batch_product_number_3 = listItemTab2.batchProductNumber;
      this.batch_order_code_2 = listItemTab2.batchProductNumber;
    } else {
      this.batch_product_number_3 = listItemTab2.batchOrderCode.slice(-9);
      this.batch_order_code_2 = listItemTab2.batchOrderCode.slice(-9);
    }

    console.log('this.batch_order_code_2', this.batch_order_code_2);
    console.log('this.batch_product_number_3', listItemTab2);
    this.editStamp.show();
  }

  closeModalEditStamp() {
    console.log('this.batch_order_code_2', this.batch_order_code_2, this.batch_product_number_3);

    this.batch_product_number_3 = this.batch_order_code_2;

    this.editStamp.hide()
  }

  changeTab(event) {
    // this.resetActiveAllTab2()
    this.activeTab = event;
  }

  removeItemTab2(type, serial) {
    console.log(type, serial);
    if (type === 1) {
      this.listItem = this.listItem.filter((res) => {
        return res.form.serial !== serial;
      });
      console.log('this.listItem', this.listItem);
      this.nextStep(2);
    } else {
      this.boxItem = this.boxItem.filter((res) => {
        return res.form.serial !== serial;
      });
      console.log('this.boxItem', this.boxItem);
      this.nextStep(2);
    }
  }

  showEdit(serial, allStamp, item) {
    console.log('allStamp', allStamp);
    console.log('item', item);
    this.serialDetail = serial;
    this.produce_time = allStamp.produceTime
    this.guarantee_days_update = allStamp.guaranteeDay;
    this.guarantee_days_max_update = allStamp.guaranteeDayMax;
    this.type_guarantee_day = allStamp.typeGuaranteeDay;
    this.type_guarantee_day_max = allStamp.typeGuaranteeDayMax;
    if (this.source === 2) {
      this.batch_product_number_3 = item.batchProductNumber;
    }
    this.editStamp.show();
  }

  submitEditTab2() {
    const body = {
      serialDetail: this.serialDetail,
      produce_time: this.produce_time, //Ngày sản xuất
      guarantee_days_update: this.guarantee_days_update, // Thời gian bảo hành
      guarantee_days_max_update: this.guarantee_days_max_update, // Kiểu thời gian bảo hành
      type_guarantee_day: this.type_guarantee_day,
      type_guarantee_day_max: this.type_guarantee_day_max,
      batch_product_number: this.batch_product_number_3,
    };
    console.log('boddyyaysdasd', body.produce_time)
    if (body.produce_time === null) {
      this.toastr.error(
        this.translate.instant('THOI_GIAN_BAO_HANH_VA_NGAY_SAN_XUAT_KHONG_TRONG'),
        '',
        {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        }
      );
      return;
    }
    if (body.guarantee_days_max_update || body.guarantee_days_max_update == 0) {
      if (!body.produce_time || !body.type_guarantee_day) {
        this.toastr.error(
          this.translate.instant('THOI_GIAN_BAO_HANH_VA_NGAY_SAN_XUAT_KHONG_TRONG'),
          '',
          {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          }
        );
        return;
      }
    }
    this.listItemTab2.map((res, i) => {
      if (res.serial === this.serialDetail) {
        res.allStamp.map((val, k) => {
          if (this.produce_time) {
            const IsoDateTo = moment(this.produce_time, 'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss');
            this.listItemTab2[i].allStamp[k]['produceTime'] = moment(IsoDateTo).format('DD-MM-YYYY')
          } else {
            this.listItemTab2[i].allStamp[k]['produceTime'] = moment(this.produce_time).format('DD-MM-YYYY')

          }
          this.listItemTab2[i].allStamp[k]['typeGuaranteeDay'] =
            this.type_guarantee_day;
          this.listItemTab2[i].allStamp[k]['typeGuaranteeDayMax'] =
            this.type_guarantee_day_max;
          this.listItemTab2[i].allStamp[k]['guaranteeDay'] = this
            .guarantee_days_update
            ? Number(this.guarantee_days_update)
            : null;
          this.listItemTab2[i].allStamp[k]['guaranteeDayMax'] = this
            .guarantee_days_max_update
            ? Number(this.guarantee_days_max_update)
            : null;
        });
        if (res.batchProductNumber !== '' && this.source === 2) {
          if (this.produce_time) {
            const IsoDateTo = moment(this.produce_time, 'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss');
            console.log('IsoDateTo', moment(IsoDateTo).format('DD-MM').replace('-', ''));
            if (res.batchProductNumber.length === 9) {
              res.batchProductNumber = res.batchProductNumber + '-' + moment(IsoDateTo).format('DD-MM').replace('-', '');
            } else {
              res.batchProductNumber = res.batchProductNumber.slice(0, -5) + '-' + moment(IsoDateTo).format('DD-MM').replace('-', '');
            }
          } else {
            if (res.batchProductNumber.length === 9) {
              res.batchProductNumber = res.batchProductNumber + '-' + moment(this.produce_time).format('DD-MM').replace('-', '');
            } else {
              res.batchProductNumber = res.batchProductNumber.slice(0, -5) + '-' + moment(this.produce_time).format('DD-MM').replace('-', '');
            }
          }
        } else {
          res.batchProductNumber = res.batchOrderCode.slice(-9) + '-' + moment(this.produce_time).format('DD-MM').replace('-', '');
        }
      }
    });
    this.resetActiveAllTab2();
    this.editStamp.hide();
    console.log('submitEditTab2', this.listItemTab2);
  }

  closeActive(e) {
    clickTracking('qcheck_batch_active', 'stamp_exit', 'batch_product_map', '');
    this.listItemTab2.map((res, i) => {
      if (res.allStamp.length > 0) {
        res.allStamp.map((val, k) => {
          this.listItemTab2[i].allStamp[k]['closeActive'] = e;
        });
      }
    });
  }

  // END TAB 2

  /*///!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!**!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/*/
  // TAB 3
  has_prod = false;
  prod_thumb: any = null;
  productId: any = null;
  product: any;
  listProducts: any = [];

  changeTab3(event) {
    this.activeTab3 = event;
    this.resetActiveAllTab3();
  }

  resetActiveAllTab3() {
    this.productId = null;
    this.product = null;
    this.prod_thumb = null;
  }

  showSettingTab3(serial) {
    this.serialDetail = serial;
    console.log(this.productId, 1, this.product);
    this.resetActiveAllTab3();
    this.editStampTab3.show();
  }

  showEditTab3(serial, allStamp) {
    console.log(this.productId, 3, this.product);

    this.serialDetail = serial;
    // this.productId = allStamp.productId
    this.prod_thumb = allStamp.productImage;

    this.productId = allStamp.productId.toString();
    this.product = {
      value: allStamp.productId.toString(),
      label: allStamp.productName,
    };
    console.log(this.productId, 1, this.product);
    // this.produce_time = allStamp.produceTime;
    // this.guarantee_days_update = allStamp.guaranteeDay;
    // this.guarantee_days_max_update = allStamp.guaranteeDayMax;
    // this.type_guarantee_day = allStamp.typeGuaranteeDay;
    // this.type_guarantee_day_max = allStamp.typeGuaranteeDayMax;
    this.editStampTab3.show();
  }

  submitEditTab3() {
    console.log('productId', this.product);
    this.listItemTab2.map((res, i) => {
      if (res.serial === this.serialDetail) {
        res.allStamp.map((val, k) => {
          this.listItemTab2[i].allStamp[k]['productId'] = this.productId
            ? Number(this.productId)
            : null;
          const product = _.find(this.listProducts, {
            id: Number(this.productId),
          });
          this.listItemTab2[i].allStamp[k]['productImage'] = this.productId
            ? product['image']
            : null;
          this.listItemTab2[i].allStamp[k]['productName'] = this.productId
            ? product['name']
            : null;
        });
      }
    });
    this.resetActiveAllTab3();
    this.editStampTab3.hide();
  }

  changeProduct(event) {
    this.productId = event ? event : null;

    const product = _.find(this.listProducts, { id: Number(this.productId) });
    console.log('this.listProducts', this.listProducts);
    console.log('this.productId', this.productId);
    console.log('product', product);
    if (product) {
      this.prod_thumb = this.productId ? product['image'] : null;
      this.product = {
        value: this.productId.toString(),
        label: product['name'],
      };
      
      this.fetchAndFillReminderConfig();
    } else {
      this.prod_thumb = null;
      this.product = null;
      this.cachedReminderConfig = null;
      this.is_override_warranty_tab2 = false;
      this.clearReminderConfigForm(this.formTab2);
    }
  }

  listProduct(e) {
    if (this.listProducts.length > 0) {
      e.map((res) => {
        let check = true;
        this.listProducts.map((value) => {
          if (value.id === res.id) {
            check = false;
          }
        });
        if (check) {
          this.listProducts.push(res);
        }
      });
    } else {
      this.listProducts.push(e);
    }
  }

  // END TAB 3

  /*///!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!**!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/*/

  //  TAB 4
  nameAction: any;
  note: any;
  // TAB 1
  nameActionTab1: any;
  noteTab1: any;
  listImageTab1: any[] = [];
  nameActionExcel: any;
  noteExcel: any;
  listImageExcel: any[] = [];
  is_log_blockchain_tab2: boolean = true;
  is_log_blockchain_tab3: boolean = true;

  // end list
  deleteImage(index: number) {
    this.listImageDistribution.splice(index, 1);
  }
  
  deleteImageTab1(index: number) {
    this.listImageTab1.splice(index, 1);
  }

  tusUploadReturnBoxImages = (item) => {
    let isValid = true;
    return new Promise((resolve) => {
      for (const image of item.target.files) {
        if (image.type.indexOf('image') === -1) {
          isValid = false;
        }
      }
      resolve(isValid);
    }).then((result) => {
      console.log(result);
      if (result) {
        for (const image of item.target.files) {
          const type = {
            name: image.name,
            type: image.type,
          };

          const fileData = new FormData();
          // @ts-ignore
          fileData.append('file', image);
          return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
            const res = JSON.parse(response._body)
            if (res.status === 200) {
              const image2 = {
                id: res.data.fileId,
                url: res.data.url,
              };
              if (this.listImageDistribution.length >= 5) {
                this.toastr.warning(
                  this.translate.instant('SO_LUONG_ANH_TOI_DA_LA_5'),
                  this.translate.instant('CANH_BAO'),
                  {
                    timeOut: 3000,
                    positionClass: 'toast-top-right',
                  }
                );
              } else {
                this.listImageDistribution.push({ ...image2, ...type });
              }


            }
          });

        }
      } else {
        this.toastr.warning(this.translate.instant('KHONG_DUNG_DINH_DANG_ANH'), this.translate.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
    });
  };

  deleteImageExcel(index: number) {
    this.listImageExcel.splice(index, 1);
  }

  tusUploadReturnBoxImagesTab1 = (item) => {
    let isValid = true;
    return new Promise((resolve) => {
      for (const image of item.target.files) {
        if (image.type.indexOf('image') === -1) {
          isValid = false;
        }
      }
      resolve(isValid);
    }).then((result) => {
      console.log(result);
      if (result) {
        for (const image of item.target.files) {
          const type = {
            name: image.name,
            type: image.type,
          };

          const fileData = new FormData();
          // @ts-ignore
          fileData.append('file', image);
          return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
            const res = JSON.parse(response._body)
            if (res.status === 200) {
              const image2 = {
                id: res.data.fileId,
                url: res.data.url,
                name: image.name,
                type: image.type,
              };
              if (this.listImageTab1.length >= 5) {
                this.toastr.warning(
                  this.translate.instant('SO_LUONG_ANH_TOI_DA_LA_5'),
                  this.translate.instant('CANH_BAO'),
                  {
                    timeOut: 3000,
                  }
                );
              } else {
                this.listImageTab1.push(image2);
              }
            } else {
              this.toastr.error('Tải ảnh không thành công', 'Lỗi');
            }
          });
        }
      } else {
        this.toastr.warning('Không đúng định dạng ảnh', 'Cảnh báo', {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    });
  }

  tusUploadReturnBoxImagesExcel = (item) => {
    let isValid = true;
    return new Promise((resolve) => {
      for (const image of item.target.files) {
        if (image.type.indexOf('image') === -1) {
          isValid = false;
        }
      }
      resolve(isValid);
    }).then((result) => {
      if (result) {
        for (const image of item.target.files) {
          const fileData = new FormData();
          // @ts-ignore
          fileData.append('file', image);
          return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
            const res = JSON.parse(response._body)
            if (res.status === 200) {
              const image2 = {
                id: res.data.fileId,
                url: res.data.url,
                name: res.data.fileName || image.name,
                type: image.type,
              };
              if (this.listImageExcel.length >= 5) {
                this.toastr.warning(
                  this.translate.instant('SO_LUONG_ANH_TOI_DA_LA_5'),
                  this.translate.instant('CANH_BAO')
                );
              } else {
                this.listImageExcel.push(image2);
              }
            } else {
              this.toastr.error(res.message, this.translate.instant('THAT_BAI'));
            }
          });
        }
      } else {
        this.toastr.error(this.translate.instant('KHONG_DUNG_DINH_DANG'), this.translate.instant('THAT_BAI'));
      }
    });
  };
  // END TAB 4

  /*///!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!**!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/!*!/*/

  nextStep(e, type?) {
    // this.step = e
    if (e === 1) {
      this.step = e;
    } else if (e === 2) {
      console.log('xem ra cai gi', this.listItem, this.boxItem);
      // this.listItem;
      if (!(this.listItem.length > 0)) {
        this.toastr.warning(this.translate.instant('DU_LIEU_KHONG_DE_TRONG'), this.translate.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }
      if (type != 'back') {
        const data = [];
        this.listItemTab1 = [];
        console.log('this.boxItem', this.boxItem);

        if (this.listItem.length > 0) {
          this.listItem.map((res) => {
            data.push({
              prefix: res.form.prefix,
              idStart: res.form.start,
              idEnd: res.form.end,
            });
            this.listItemTab1.push({
              prefix: res.form.prefix,
              idStart: res.form.start,
              idEnd: res.form.end,
              serial: res.form.serial,
              type: 1,
            });
          });
        }
        if (this.boxItem.length > 0) {
          this.boxItem.map((res) => {
            console.log('âsdasdasd', this.boxItem)
            if (res.form.prefix !== '' && res.form.end !== '' && res.form.start !== '') {
              data.push({
                prefix: res.form.prefix,
                idStart: res.form.start,
                idEnd: res.form.end,
              });
              this.listItemTab1.push({
                prefix: res.form.prefix,
                idStart: res.form.start,
                idEnd: res.form.end,
                type: 2,
                serial: res.form.serial,
                name: res.form.name,
              });
            }
          });
        }
        // console.log('data', data)
        this.listItemTab2 = [];
        this.activeTempNewService
          .batchSeperateValidate({ items: data })
          .subscribe(
            (res) => {
              if (res.code === 1) {
                res.data.items.map((val, i) => {
                  const check = _.find(this.listItemTab1, {
                    prefix: val.prefix,
                    idStart: val.idStart,
                    idEnd: val.idEnd,
                  });
                  if (check) {
                    this.listItemTab2.push({
                      ...check,
                      allStamp: val.allStamp,
                      errorMessage: val.errorMessage,
                      block: val.block,
                      batchOrderCode: val.batchOrderCode,
                      batchProductNumber: val.batchProductNumber,
                    });
                  }
                });
                console.log('validateaaaa12312', this.listItemTab2);
                if (this.batch_product_number_2 === '') {
                  console.log(789);
                } else {
                  console.log(456);
                }

                if (this.source === 2) {
                  if (this.listItemTab2.length > 1) {
                    let flag = 1;
                    for (let i = 0; i < this.listItemTab2.length - 1; i++) {
                      for (let j = i + 1; j < this.listItemTab2.length; ++j) {
                        if (
                          this.listItemTab2[i].batchOrderCode !==
                          this.listItemTab2[j].batchOrderCode
                        ) {
                          flag = 0;
                          break;
                        }
                      }
                    }
                    if (flag === 1) {
                      this.is_check_batch_number = false;
                      // this.batch_order_code = this.listItemTab2[0].batchOrderCode ? this.listItemTab2[0].batchOrderCode.slice(-9) : this.listItemTab2[0].batchOrderCode;
                      // this.batch_product_number_2 = this.batch_order_code;
                    } else {
                      this.is_check_batch_number = true;
                    }
                    console.log('validateaaaa', this.listItemTab2);
                    console.log('flag', flag);
                  } else {
                    if (this.batch_product_number_2 === '') {
                      if (this.listItemTab2[0]['batchProductNumber']) {
                        this.batch_product_number_2 = this.listItemTab2[0]['batchProductNumber'];
                        this.batch_order_code = this.listItemTab2[0]['batchOrderCode'];
                      } else {
                        this.batch_order_code = this.listItemTab2[0]['batchOrderCode'] ? this.listItemTab2[0]['batchOrderCode'].slice(-9) : null;
                        this.batch_product_number_2 = this.batch_order_code;
                      }
                    }
                  }
                }
                this.step = e;
              } else {
                this.toastr.warning(res.message, this.translate.instant('THONG_BAO'), {
                  timeOut: 4000,
                  positionClass: 'toast-top-right',
                });
              }
            },
            (err) => {
              this.toastr.warning(this.translate.instant('ERR_OCCURRED'), this.translate.instant('THONG_BAO'), {
                timeOut: 4000,
                positionClass: 'toast-top-right',
              });
            }
          );
      } else {
        this.step = e;
      }
    } else if (e === 3) {
      console.log(123123123, this.listItemTab2);
      if (this.activeTab === 1) {
        if (this.guarantee_days_max_update) {
          if (!this.produce_time || !this.type_guarantee_day) {
            this.toastr.error(
              this.translate.instant('THOI_GIAN_BAO_HANH_VA_NGAY_SAN_XUAT_KHONG_TRONG'),
              '',
              {
                timeOut: 1000,
                positionClass: 'toast-top-right',
              }
            );
            return;
          }
        }
        this.listItemTab2.map((res, i) => {
          if (res.allStamp.length > 0) {
            res.allStamp.map((val, k) => {
              this.listItemTab2[i].allStamp[k]['produceTime'] = this
                .produce_time
                ? moment(this.produce_time).format('DD-MM-YYYY')
                : null;
              this.listItemTab2[i].allStamp[k]['typeGuaranteeDay'] =
                this.type_guarantee_day;
              this.listItemTab2[i].allStamp[k]['typeGuaranteeDayMax'] =
                this.type_guarantee_day_max;
              this.listItemTab2[i].allStamp[k]['guaranteeDay'] = this.guarantee_days_update ? Number(this.guarantee_days_update) : null;
              this.listItemTab2[i].allStamp[k]['guaranteeDayMax'] = this.guarantee_days_max_update ? Number(this.guarantee_days_max_update) : null;
              this.listItemTab2[i].allStamp[k]['guaranteeDayMax'] = this.guarantee_days_max_update ? Number(this.guarantee_days_max_update) : null;
              this.listItemTab2[i].allStamp[k]['batchOrderCode'] = this.batch_product_number_2 ? this.batch_product_number_2 : this.batch_product_number_3;
              this.listItemTab2[i].allStamp[k]['batchProductNumber'] = this.batch_product_number_2 ? this.batch_product_number_2 : this.batch_product_number_3;
            });
          }
        });
      }

      let messErr = '';
      this.listItemTab2.map((res, i) => {
        if (this.listItemTab2[i].block) {
          messErr = this.translate.instant('TEM_SERIAL_KHONG_HOP_LE', { serial: this.listItemTab2[i]['serial'] });
        }
      });

      if (messErr) {
        this.toastr.warning(messErr, this.translate.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }

      this.step = e;
    } else if (e === 4) {
      console.log(' this.listItemTab244', this.listItemTab2);
      if (this.activeTab3 === 1) {
        this.listItemTab2.map((res, i) => {
          if (res.allStamp.length > 0) {
            res.allStamp.map((val, k) => {
              this.listItemTab2[i].allStamp[k]['productId'] = this.productId
                ? Number(this.productId)
                : null;
              const product = _.find(this.listProducts, {
                id: Number(this.productId),
              });
              this.listItemTab2[i].allStamp[k]['productImage'] = this.productId
                ? product['image']
                : null;
              this.listItemTab2[i].allStamp[k]['productName'] = this.productId
                ? product['name']
                : null;
            });
          }
        });
      }
      this.checkActive();
      let messErr = '';
      this.listItemTab2.map((res, i) => {
        if (res.allStamp.length > 0) {
          res.allStamp.map((val, k) => {
            if (
              !this.listItemTab2[i].allStamp[k]['action'] ||
              this.listItemTab2[i].allStamp[k]['action'] === 0
            ) {
              messErr = this.translate.instant('TEM_SERIAL_CHUA_DUOC_KICH_HOAT_GAN', { serial: this.listItemTab2[i]['serial'] });
            }
          });
        }
      });
      if (messErr) {
        this.toastr.warning(messErr, this.translate.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }

      this.step = e;
    }
  }

  checkActive() {
    this.listItemTab2.map((res, i) => {
      if (res.allStamp.length > 0) {
        res.allStamp.map((val, k) => {
          const listItemTab2 = this.listItemTab2[i].allStamp[k];
          console.log(listItemTab2['productId'], listItemTab2['closeActive']);
          if (listItemTab2['productId'] && !listItemTab2['closeActive']) {
            this.listItemTab2[i].allStamp[k]['action'] = 3;
          } else if (listItemTab2['productId'] && listItemTab2['closeActive']) {
            this.listItemTab2[i].allStamp[k]['action'] = 1;
          } else if (
            !listItemTab2['productId'] &&
            listItemTab2['closeActive']
          ) {
            this.listItemTab2[i].allStamp[k]['action'] = 0;
          } else if (
            !listItemTab2['productId'] &&
            !listItemTab2['closeActive']
          ) {
            this.listItemTab2[i].allStamp[k]['action'] = 2;
          }
        });
      }
    });
  }

  disableSubmitFormConfirm = false;

  submitTab2() {
    if (this.is_override_warranty_tab2) {
      if (this.formTab2.value.is_maintenance_reminder) {
        if (!this.formTab2.value.maintenance_cycle || parseInt(this.formTab2.value.maintenance_cycle) <= 0) {
          this.toastr.warning('Vui lòng nhập thời gian bảo dưỡng định kỳ lớn hơn 0', 'Cảnh báo:', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }

      if (this.formTab2.value.maintenance_mode === 'recurring' && this.formTab2.value.is_extend_maintenance) {
        if (!this.formTab2.value.extend_limit || parseInt(this.formTab2.value.extend_limit) <= 0) {
          this.toastr.warning('Vui lòng nhập giới hạn số lần gửi sau khi hết hạn BH lớn hơn 0', 'Cảnh báo:', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }

      if (this.formTab2.value.is_expired_reminder) {
        if (!this.formTab2.value.expired_cycle || parseInt(this.formTab2.value.expired_cycle) <= 0) {
          this.toastr.warning('Vui lòng nhập thời gian nhắc trước khi hết hạn lớn hơn 0', 'Cảnh báo:', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }
    }
    
    clickTracking(
      'qcheck_batch_active',
      'active_submit',
      'qcheck_batch_manage',
      ''
    );
    this.is_loading = true;
    
    const dataValidate = [];
    if (this.listItem.length > 0) {
      this.listItem.map((res) => {
        dataValidate.push({
          prefix: res.form.prefix,
          idStart: res.form.start,
          idEnd: res.form.end,
        });
      });
    }

    if (dataValidate.length === 0) {
      this.is_loading = false;
      this.toastr.warning(this.translate.instant('DU_LIEU_KHONG_DE_TRONG'), this.translate.instant('CANH_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    this.activeTempNewService.batchSeperateValidate({ items: dataValidate }).subscribe(
      (resValidate) => {
        if (resValidate.code === 1) {
          // Xóa lỗi cũ trên UI
          this.listItem.forEach(item => {
            if (item.messageError && item.messageError.serial) {
              item.messageError.serial.state = false;
              item.messageError.serial.text = '';
            }
          });

          let hasError = false;
          const items = [];

          resValidate.data.items.forEach((val) => {
            let errorText = '';
            
            // 1. Check lỗi ở cấp độ dải tem (val)
            if (val.block === true || val.block === 1) {
              hasError = true;
              errorText = val.errorMessage || this.translate.instant('TEM_SERIAL_KHONG_HOP_LE', { serial: `${val.prefix}-${val.idStart || ''} -> ${val.prefix}-${val.idEnd || ''}` });
            }

            // 2. Parse các tem chi tiết bên trong (nếu có)
            if (val.allStamp && val.allStamp.length > 0) {
              val.allStamp.forEach((stampItem) => {
                if (stampItem.block === 1 || stampItem.block === true) {
                  hasError = true;
                  errorText = stampItem.errorMessage || this.translate.instant('TEM_SERIAL_KHONG_HOP_LE', { serial: `${stampItem.prefix}-${stampItem.idStart || ''}` });
                } else {
                  if (this.configModeTab2 === 'individual') {
                    const matchedListItem = this.listItem.find(li =>
                      li.form.prefix.toUpperCase() === stampItem.prefix &&
                      li.form.start == stampItem.idStart
                    );
                    const indvForm = matchedListItem ? matchedListItem.form : null;
                    items.push({
                      prefix: stampItem.prefix,
                      idStart: stampItem.idStart,
                      idEnd: stampItem.idEnd,
                      bundleType: 0,
                      productId: indvForm && indvForm.productId ? indvForm.productId : null,
                      action: (indvForm && indvForm.productId) ? 3 : 2,
                      produceTime: indvForm && indvForm.produceTime ? moment(indvForm.produceTime).format('DD-MM-YYYY') : null,
                      typeGuaranteeDay: indvForm && indvForm.typeGuaranteeDay ? indvForm.typeGuaranteeDay : 'months',
                      typeGuaranteeDayMax: indvForm && indvForm.typeGuaranteeDayMax ? indvForm.typeGuaranteeDayMax : 'months',
                      guaranteeDay: indvForm && indvForm.guaranteeDay ? indvForm.guaranteeDay : null,
                      guaranteeDayMax: indvForm && indvForm.guaranteeDayMax ? indvForm.guaranteeDayMax : null,
                      batch_product_number: stampItem.batchProductNumber ? stampItem.batchProductNumber : null,
                    });
                  } else {
                    items.push({
                      prefix: stampItem.prefix,
                      idStart: stampItem.idStart,
                      idEnd: stampItem.idEnd,
                      bundleType: 0,
                      productId: this.productId,
                      action: this.productId ? 3 : 2, // 3: Kích hoạt & Gán sản phẩm, 2: Chỉ kích hoạt
                      produceTime: this.produce_time ? moment(this.produce_time).format('DD-MM-YYYY') : null,
                      typeGuaranteeDay: this.type_guarantee_day ? this.type_guarantee_day : 'months',
                      typeGuaranteeDayMax: this.type_guarantee_day_max ? this.type_guarantee_day_max : 'months',
                      guaranteeDay: this.guarantee_days_update ? this.guarantee_days_update : null,
                      guaranteeDayMax: this.guarantee_days_max_update ? this.guarantee_days_max_update : null,
                      batch_product_number: stampItem.batchProductNumber ? stampItem.batchProductNumber : null,
                    });
                  }
                }
              });
            }

            // Map lại lỗi vào UI
            if (errorText) {
              const matchedItem = this.listItem.find(item => 
                item.form.prefix == val.prefix && 
                item.form.start == val.idStart && 
                item.form.end == val.idEnd
              );
              if (matchedItem && matchedItem.messageError && matchedItem.messageError.serial) {
                matchedItem.messageError.serial.state = true;
                matchedItem.messageError.serial.text = errorText;
              }
            }
          });

          if (hasError) {
            this.is_loading = false;
            this.toastr.warning('Có dải tem không hợp lệ, vui lòng kiểm tra danh sách', this.translate.instant('CANH_BAO'), {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
            return;
          }

          if (items.length === 0) {
            this.is_loading = false;
            this.toastr.warning('Không có tem nào hợp lệ để kích hoạt', this.translate.instant('THONG_BAO'), {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
            return;
          }

          const data = {
            name: this.nameAction,
            note: this.note,
            document: {
              items: this.listImageDistribution,
            },
            items: items,
            enableBlockchain: this.is_log_blockchain_tab2,
            warrantyReminderConfig: this.is_override_warranty_tab2 ? {
              reminderMaintain: this.formTab2.value.is_maintenance_reminder ? {
                isSelect: true,
                mode: this.formTab2.value.maintenance_mode === 'once' ? 'ONCE' : 'REPEAT',
                reminderContinue: this.formTab2.value.is_extend_maintenance || false,
                numberTimeNotify: this.formTab2.value.maintenance_cycle ? parseInt(this.formTab2.value.maintenance_cycle as any) : 0,
                timeType: this.formTab2.value.maintenance_cycle_unit === 'days' ? 'DAY' : (this.formTab2.value.maintenance_cycle_unit === 'months' ? 'MONTH' : 'YEAR'),
                numberOfLimit: this.formTab2.value.maintenance_mode === 'once' ? undefined : ((this.formTab2.value.is_extend_maintenance && this.formTab2.value.extend_limit) ? parseInt(this.formTab2.value.extend_limit) : 0)
              } : {
                isSelect: false,
                mode: 'ONCE',
                reminderContinue: false,
                numberTimeNotify: 0,
                timeType: 'DAY',
                numberOfLimit: undefined
              },
              reminderExpired: this.formTab2.value.is_expired_reminder ? {
                isSelect: true,
                mode: this.formTab2.value.expired_mode === 'once' ? 'ONCE' : 'REPEAT',
                reminderContinue: false,
                numberTimeNotify: this.formTab2.value.expired_cycle ? parseInt(this.formTab2.value.expired_cycle as any) : 0,
                timeType: this.formTab2.value.expired_cycle_unit === 'days' ? 'DAY' : (this.formTab2.value.expired_cycle_unit === 'months' ? 'MONTH' : 'YEAR'),
                numberOfLimit: this.formTab2.value.expired_mode === 'once' ? undefined : 1
              } : {
                isSelect: false,
                mode: 'ONCE',
                reminderContinue: false,
                numberTimeNotify: 0,
                timeType: 'DAY',
                numberOfLimit: undefined
              }
            } : undefined,
            is_override: this.is_override_warranty_tab2
          };

          console.log('submitTab2 data', data);

          this.activeTempNewService.batchSeperate(data).subscribe(
            (res) => {
              if (res.code === 1) {
                if (res.data.success > 0) {
                  this.toastr.success(
                    this.translate.instant('THANH_CONG_FAIL_MSG', { success: res.data.success, fail: res.data.fail }),
                    this.translate.instant('THONG_BAO'),
                    {
                      timeOut: 4000,
                      positionClass: 'toast-top-right',
                    }
                  );
                } else {
                  this.toastr.warning(
                    this.translate.instant('THANH_CONG_FAIL_MSG', { success: res.data.success, fail: res.data.fail }),
                    this.translate.instant('THONG_BAO'),
                    {
                      timeOut: 4000,
                      positionClass: 'toast-top-right',
                    }
                  );
                }

                this.hideCrating.emit({ updated: true });
                this.closeActive(true);
              } else {
                this.toastr.warning(res.message, this.translate.instant('THONG_BAO'), {
                  timeOut: 4000,
                  positionClass: 'toast-top-right',
                });
              }
              this.is_loading = false;
            },
            (err) => {
              this.is_loading = false;
              if (err.code === 0) {
                this.toastr.warning(err.message, this.translate.instant('THONG_BAO'), {
                  timeOut: 4000,
                  positionClass: 'toast-top-right',
                });
              } else {
                this.toastr.error(this.translate.instant('LOI_MAY_CHU'), this.translate.instant('THAT_BAI'), {
                  timeOut: 4000,
                  positionClass: 'toast-top-right',
                });
              }
            }
          );
        } else {
          this.is_loading = false;
          this.toastr.warning(resValidate.message, this.translate.instant('THONG_BAO'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        }
      },
      (err) => {
        this.is_loading = false;
        this.toastr.warning(this.translate.instant('ERR_OCCURRED'), this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    );
  }

  submitAssignOnly() {
    clickTracking(
      'qcheck_batch_active',
      'assign_only_submit',
      'qcheck_batch_manage',
      ''
    );
    this.is_loading = true;

    const dataValidate = [];
    if (this.listItem.length > 0) {
      this.listItem.map((res) => {
        dataValidate.push({
          prefix: res.form.prefix,
          idStart: res.form.start,
          idEnd: res.form.end,
        });
      });
    }

    if (dataValidate.length === 0) {
      this.is_loading = false;
      this.toastr.warning(this.translate.instant('DU_LIEU_KHONG_DE_TRONG'), this.translate.instant('CANH_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    this.activeTempNewService.batchSeperateValidate({ items: dataValidate }).subscribe(
      (resValidate) => {
        if (resValidate.code === 1) {
          this.listItem.forEach(item => {
            if (item.messageError && item.messageError.serial) {
              item.messageError.serial.state = false;
              item.messageError.serial.text = '';
            }
          });

          let hasError = false;
          const items = [];

          resValidate.data.items.forEach((val) => {
            let errorText = '';
            if (val.block === true || val.block === 1) {
              hasError = true;
              errorText = val.errorMessage || this.translate.instant('TEM_SERIAL_KHONG_HOP_LE', { serial: `${val.prefix}-${val.idStart || ''} -> ${val.prefix}-${val.idEnd || ''}` });
            }

            if (val.allStamp && val.allStamp.length > 0) {
              val.allStamp.forEach((stampItem) => {
                if (stampItem.block === 1 || stampItem.block === true) {
                  hasError = true;
                  errorText = stampItem.errorMessage || this.translate.instant('TEM_SERIAL_KHONG_HOP_LE', { serial: `${stampItem.prefix}-${stampItem.idStart || ''}` });
                } else {
                  if (this.configModeTab2 === 'individual') {
                    const matchedListItem = this.listItem.find(li =>
                      li.form.prefix.toUpperCase() === stampItem.prefix &&
                      li.form.start == stampItem.idStart
                    );
                    const indvForm = matchedListItem ? matchedListItem.form : null;
                    items.push({
                      prefix: stampItem.prefix,
                      idStart: stampItem.idStart,
                      idEnd: stampItem.idEnd,
                      bundleType: 0,
                      productId: indvForm && indvForm.productId ? indvForm.productId : null,
                      action: 1, // Chỉ gán sản phẩm
                      produceTime: indvForm && indvForm.produceTime ? moment(indvForm.produceTime).format('DD-MM-YYYY') : null,
                      typeGuaranteeDay: indvForm && indvForm.typeGuaranteeDay ? indvForm.typeGuaranteeDay : 'months',
                      typeGuaranteeDayMax: indvForm && indvForm.typeGuaranteeDayMax ? indvForm.typeGuaranteeDayMax : 'months',
                      guaranteeDay: indvForm && indvForm.guaranteeDay ? indvForm.guaranteeDay : null,
                      guaranteeDayMax: indvForm && indvForm.guaranteeDayMax ? indvForm.guaranteeDayMax : null,
                      batch_product_number: stampItem.batchProductNumber ? stampItem.batchProductNumber : null,
                    });
                  } else {
                    items.push({
                      prefix: stampItem.prefix,
                      idStart: stampItem.idStart,
                      idEnd: stampItem.idEnd,
                      bundleType: 0,
                      productId: this.productId,
                      action: 1, // Chỉ gán sản phẩm
                      produceTime: this.produce_time ? moment(this.produce_time).format('DD-MM-YYYY') : null,
                      typeGuaranteeDay: this.type_guarantee_day ? this.type_guarantee_day : 'months',
                      typeGuaranteeDayMax: this.type_guarantee_day_max ? this.type_guarantee_day_max : 'months',
                      guaranteeDay: this.guarantee_days_update ? this.guarantee_days_update : null,
                      guaranteeDayMax: this.guarantee_days_max_update ? this.guarantee_days_max_update : null,
                      batch_product_number: stampItem.batchProductNumber ? stampItem.batchProductNumber : null,
                    });
                  }
                }
              });
            }

            if (errorText) {
              const matchedItem = this.listItem.find(item =>
                item.form.prefix == val.prefix &&
                item.form.start == val.idStart &&
                item.form.end == val.idEnd
              );
              if (matchedItem && matchedItem.messageError && matchedItem.messageError.serial) {
                matchedItem.messageError.serial.state = true;
                matchedItem.messageError.serial.text = errorText;
              }
            }
          });

          if (hasError) {
            this.is_loading = false;
            this.toastr.warning('Có dải tem không hợp lệ, vui lòng kiểm tra danh sách', this.translate.instant('CANH_BAO'), {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
            return;
          }

          if (items.length === 0) {
            this.is_loading = false;
            this.toastr.warning('Không có tem nào hợp lệ để gán sản phẩm', this.translate.instant('THONG_BAO'), {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
            return;
          }

          const data = {
            name: this.nameAction,
            note: this.note,
            document: {
              items: this.listImageDistribution,
            },
            items: items,
            enableBlockchain: this.is_log_blockchain_tab2
          };

          console.log('submitAssignOnly data', data);

          this.activeTempNewService.batchSeperate(data).subscribe(
            (res) => {
              if (res.code === 1) {
                if (res.data.success > 0) {
                  this.toastr.success(
                    this.translate.instant('THANH_CONG_FAIL_MSG', { success: res.data.success, fail: res.data.fail }),
                    this.translate.instant('THONG_BAO'),
                    {
                      timeOut: 4000,
                      positionClass: 'toast-top-right',
                    }
                  );
                } else {
                  this.toastr.warning(
                    this.translate.instant('THANH_CONG_FAIL_MSG', { success: res.data.success, fail: res.data.fail }),
                    this.translate.instant('THONG_BAO'),
                    {
                      timeOut: 4000,
                      positionClass: 'toast-top-right',
                    }
                  );
                }
                this.hideCrating.emit({ updated: true });
                this.closeActive(true);
              } else {
                this.toastr.warning(res.message, this.translate.instant('THONG_BAO'), {
                  timeOut: 4000,
                  positionClass: 'toast-top-right',
                });
              }
              this.is_loading = false;
            },
            (err) => {
              this.is_loading = false;
              if (err.code === 0) {
                this.toastr.warning(err.message, this.translate.instant('THONG_BAO'), {
                  timeOut: 4000,
                  positionClass: 'toast-top-right',
                });
              } else {
                this.toastr.error(this.translate.instant('LOI_MAY_CHU'), this.translate.instant('THAT_BAI'), {
                  timeOut: 4000,
                  positionClass: 'toast-top-right',
                });
              }
            }
          );
        } else {
          this.is_loading = false;
          this.toastr.warning(resValidate.message, this.translate.instant('THONG_BAO'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        }
      },
      (err) => {
        this.is_loading = false;
        this.toastr.warning(this.translate.instant('ERR_OCCURRED'), this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    );
  }

  submitFormConfirm() {
    if (this.is_override_warranty_tab1) {
      if (this.FormActiveStamp.value.is_maintenance_reminder) {
        if (!this.FormActiveStamp.value.maintenance_cycle || parseInt(this.FormActiveStamp.value.maintenance_cycle) <= 0) {
          this.toastr.warning('Vui lòng nhập thời gian bảo dưỡng định kỳ lớn hơn 0', 'Cảnh báo:', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }

      if (this.FormActiveStamp.value.maintenance_mode === 'recurring' && this.FormActiveStamp.value.is_extend_maintenance) {
        if (!this.FormActiveStamp.value.extend_limit || parseInt(this.FormActiveStamp.value.extend_limit) <= 0) {
          this.toastr.warning('Vui lòng nhập giới hạn số lần gửi sau khi hết hạn BH lớn hơn 0', 'Cảnh báo:', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }

      if (this.FormActiveStamp.value.is_expired_reminder) {
        if (!this.FormActiveStamp.value.expired_cycle || parseInt(this.FormActiveStamp.value.expired_cycle) <= 0) {
          this.toastr.warning('Vui lòng nhập thời gian nhắc trước khi hết hạn lớn hơn 0', 'Cảnh báo:', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }
    }
    
    clickTracking(
      'qcheck_batch_active',
      'active_submit',
      'qcheck_batch_manage',
      ''
    );
    this.is_loading = true;
    const items = [];
    console.log('this.listItemTab2', this.listItemTab2);

    this.listItemTab2.map((res, i) => {
      if (res.allStamp.length > 0) {
        res.allStamp.map((val, k) => {
          const listItemTab2 = this.listItemTab2[i].allStamp[k];
          console.log('asssss', listItemTab2.batch_product_number);
          let check = true;

          if (items.length > 0) {
            items.map((value) => {
              if (
                value.prefix == listItemTab2.prefix &&
                value.idStart == listItemTab2.idStart &&
                value.idEnd == listItemTab2.idEnd
              ) {
                check = false;
              }
            });
          }

          if (check) {
            items.push({
              prefix: listItemTab2.prefix,
              idStart: listItemTab2.idStart,
              idEnd: listItemTab2.idEnd,
              bundleType: listItemTab2.bundleType,
              productId: listItemTab2.productId,
              action: listItemTab2.action,
              produceTime: listItemTab2.closeActive ? null : listItemTab2.produceTime,
              typeGuaranteeDay: listItemTab2.closeActive ? 'months' : listItemTab2.typeGuaranteeDay,
              typeGuaranteeDayMax: listItemTab2.closeActive ? 'months' : listItemTab2.typeGuaranteeDayMax,
              guaranteeDay: listItemTab2.closeActive ? null : listItemTab2.guaranteeDay,
              guaranteeDayMax: listItemTab2.closeActive ? null : listItemTab2.guaranteeDayMax,
              batch_product_number: res.batchProductNumber ? res.batchProductNumber : res.batchOrderCode,
            });
          }
        });
      }
    });

    console.log('items2', items);
    // return;

    const data = {
      name: this.nameActionTab1,
      note: this.noteTab1,
      document: {
        items: this.listImageTab1,
      },
      items: items,
      enableBlockchain: this.FormActiveStamp.value.is_log_blockchain,
      warrantyReminderConfig: this.is_override_warranty_tab1 ? {
        reminderMaintain: this.FormActiveStamp.value.is_maintenance_reminder ? {
          isSelect: true,
          mode: this.FormActiveStamp.value.maintenance_mode === 'once' ? 'ONCE' : 'REPEAT',
          reminderContinue: this.FormActiveStamp.value.is_extend_maintenance || false,
          numberTimeNotify: this.FormActiveStamp.value.maintenance_cycle ? parseInt(this.FormActiveStamp.value.maintenance_cycle as any) : 0,
          timeType: this.FormActiveStamp.value.maintenance_cycle_unit === 'days' ? 'DAY' : (this.FormActiveStamp.value.maintenance_cycle_unit === 'months' ? 'MONTH' : 'YEAR'),
          numberOfLimit: this.FormActiveStamp.value.maintenance_mode === 'once' ? undefined : ((this.FormActiveStamp.value.is_extend_maintenance && this.FormActiveStamp.value.extend_limit) ? parseInt(this.FormActiveStamp.value.extend_limit) : 0)
        } : {
          isSelect: false,
          mode: 'ONCE',
          reminderContinue: false,
          numberTimeNotify: 0,
          timeType: 'DAY',
          numberOfLimit: undefined
        },
        reminderExpired: this.FormActiveStamp.value.is_expired_reminder ? {
          isSelect: true,
          mode: this.FormActiveStamp.value.expired_mode === 'once' ? 'ONCE' : 'REPEAT',
          reminderContinue: false,
          numberTimeNotify: this.FormActiveStamp.value.expired_cycle ? parseInt(this.FormActiveStamp.value.expired_cycle as any) : 0,
          timeType: this.FormActiveStamp.value.expired_cycle_unit === 'days' ? 'DAY' : (this.FormActiveStamp.value.expired_cycle_unit === 'months' ? 'MONTH' : 'YEAR'),
          numberOfLimit: this.FormActiveStamp.value.expired_mode === 'once' ? undefined : 1
        } : {
          isSelect: false,
          mode: 'ONCE',
          reminderContinue: false,
          numberTimeNotify: 0,
          timeType: 'DAY',
          numberOfLimit: undefined
        }
      } : undefined,
      is_override: this.is_override_warranty_tab1
    };
    console.log('data', data);

    this.activeTempNewService.batchSeperate(data).subscribe(
      (res) => {
        if (res.code === 1) {
          if (res.data.success > 0) {
            this.toastr.success(
              this.translate.instant('THANH_CONG_FAIL_MSG', { success: res.data.success, fail: res.data.fail }),
              this.translate.instant('THONG_BAO'),
              {
                timeOut: 4000,
                positionClass: 'toast-top-right',
              }
            );
          } else {
            this.toastr.warning(
              this.translate.instant('THANH_CONG_FAIL_MSG', { success: res.data.success, fail: res.data.fail }),
              this.translate.instant('THONG_BAO'),
              {
                timeOut: 4000,
                positionClass: 'toast-top-right',
              }
            );
          }

          this.hideCrating.emit({ updated: true });
        } else {
          this.toastr.warning(res.message, this.translate.instant('THONG_BAO'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        }
      },
      (err) => {
        this.toastr.warning(`${err.message}`, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    );
  }

  // cratingStampsChange(e) {
  //   this.reset(e)
  // }

  reset(e) {
    $('.slt-batchstamp').val('').trigger('change');

    // this.listContent = [];
    // this.removeCodeListAll();
    // this.groupItems = [];
    // this.errorMessage = [];
    // this.stampList = [];
    // this.formCratingBatch.reset();
    // this.formCratingBatch.get('is_cratingStamps').setValue(e);
    // this.formCratingBatch.get('is_request').setValue(true);
    // this.formCratingBatch.get('is_routing').setValue(false);
    // this.listImageDistribution = [];
    //
    // this.addressAgent = '';
    // this.showCityAgent = false;
    // this.showDistrictAgent = false;
    // $('.distributionAgent1').val(null).trigger('change');
    // $('.cityAgent').val(null).trigger('change');
    // $('.districtAgent').val(null).trigger('change');
    // $('.js-example-basic-multiple').val([]).trigger('change');
    // $('.districtForAgencyArea-multiple').val([]).trigger('change');
    // $('.city').val([]).trigger('change');
    // $('.district').val([]).trigger('change');
  }

  // boxRetalStamps

  // end boxRetalStamps
  isNaN(x) {
    // Ép kiểu Number cho biến x
    x = Number(x);
    // Nếu x là NaN, NaN != NaN trả về true, các trường hợp khác sẽ trả về false
    return x != x;
  }

  // codeList

  isActiveStamp(): boolean {
    if (this.batch_detail.status !== 1) {
      return true;
    }
  }

  // tslint:disable-next-line:member-ordering

  changeTabBatch(event) {
    this.activeTabBatch = event;
    console.log(this.activeTabBatch);
    this.changeProductNew(null);
    this.productId = null;
    this.product = null;
    this.prod_thumb = null;

    // Clear Tab 1
    this.is_override_warranty_tab1 = false;
    this.clearReminderConfigForm(this.FormActiveStamp);
    this.nameActionTab1 = '';
    this.noteTab1 = '';
    this.listImageTab1 = [];

    // Clear Tab 2
    this.is_override_warranty_tab2 = false;
    this.clearReminderConfigForm(this.formTab2);
    this.nameAction = '';
    this.note = '';
    this.listImageDistribution = [];
    this.is_log_blockchain_tab2 = false;
    this.cachedReminderConfig = null;
    this.configModeTab2 = 'global';
    this.listItemTab2 = [];

    // Clear Tab 2 - Dải tem
    this.prefix = this.batch_detail ? (this.batch_detail.prefix || '') : '';
    this.start = null;
    this.end = null;
    this.listItem = [];
    this.errorStep1 = false;
    this.errorMessageStep1 = '';

    // Clear Tab 2 - Global config (Tất cả)
    this.produce_time = null;
    this.guarantee_days_update = null;
    this.type_guarantee_day = 'months';
    this.guarantee_days_max_update = null;
    this.type_guarantee_day_max = 'months';

    // Reset file inputs để cho phép chọn lại ảnh
    const fileInputIds = ['tusUploadTab1', 'tusUpload', 'tusUploadExcel'];
    fileInputIds.forEach(id => {
      const el = document.getElementById(id) as HTMLInputElement;
      if (el) el.value = '';
    });
  }

  changeTabUpload(event) {
    this.activeUpload = event;
    console.log(this.activeUpload);
  }

  changeConfigModeTab2(mode: string) {
    if (this.configModeTab2 === mode) return; // Không làm gì nếu đang ở tab đó rồi
    this.configModeTab2 = mode;

    // Clear Global config (Tất cả)
    this.productId = null;
    this.product = null;
    this.prod_thumb = null;
    this.produce_time = null;
    this.guarantee_days_update = null;
    this.type_guarantee_day = 'months';
    this.guarantee_days_max_update = null;
    this.type_guarantee_day_max = 'months';

    // Clear Individual config (Lựa chọn) - reset form data trong từng item
    if (this.listItem && this.listItem.length > 0) {
      this.listItem.forEach(item => {
        if (item.form) {
          item.form.productId = null;
          item.form.produceTime = null;
          item.form.guaranteeDay = null;
          item.form.typeGuaranteeDay = 'months';
          item.form.guaranteeDayMax = null;
          item.form.typeGuaranteeDayMax = 'months';
        }
      });
    }

    // Clear Ghi đè cấu hình nhắc hẹn bảo hành
    this.is_override_warranty_tab2 = false;
    this.clearReminderConfigForm(this.formTab2);
    this.cachedReminderConfig = null;
  }

  /** Gộp 2 button */
  getListProduct() {
    this.productService
      .listProduct({ status: 1, limit: 2000 })
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          const list = [];
          for (const _data of res.data.products) {
            list.push({
              value: _data.id,
              label: _data.name,
              barcode: _data.sku,
            });
          }
          this.list_product = list;
        } else {
          console.log('listProduct:error', res);
        }
      })
      .catch((err: any) => {
        console.log('listProduct:catch', err);
      });
  }

  choiceProduct($event) {
    this.choice_product = $event;
  }

  setBuyOnline($event) {
    if (
      this.FormActiveStamp.get('active_buy_online').value &&
      this.user.seller_id
    ) {
      const barcode = this.choice_product.barcode;
      if (barcode) {
        this.connectService
          .checkBuyOnSeller(this.user.seller_id, barcode)
          .subscribe((res) => {
            this.no_exist_on_seller = !res.data ? true : false;
          });
      }
    } else {
      this.no_exist_on_seller = false;
    }
  }

  is_batch_generate = true;
  // tslint:disable-next-line:member-ordering
  batch_product_number: any;

  createForm() {
    const defaultReminderGroup = {
      is_override_reminder: [false],
      is_maintenance_reminder: [false],
      is_extend_maintenance: [false],
      maintenance_mode: ['once'],
      maintenance_cycle: [null],
      maintenance_cycle_unit: ['months'],
      extend_limit: [null],
      is_expired_reminder: [false],
      expired_mode: ['once'],
      expired_cycle: [null],
      expired_cycle_unit: ['months'],
    };

    if (this.source === 2) {
      this.FormActiveStamp = this.fb.group({
        product_id: [null],
        produce_time: [null],
        guarantee_days: [null],
        guarantee_days_max: [null],
        guarantee_days_update: [null],
        guarantee_days_max_update: [null],
        type_guarantee_day: ['months'],
        type_guarantee_day_max: ['months'],
        count_child: [null],
        name_child: [null],
        is_log_blockchain: [true],
        active_buy_online: [null],
        batch_product_number: [
          { value: this.batch_product_number, disabled: true },
        ],
        require_activation: [true],
        ...defaultReminderGroup
      });
    } else {
      this.FormActiveStamp = this.fb.group({
        product_id: [null],
        produce_time: [null],
        guarantee_days: [null],
        guarantee_days_max: [null],
        guarantee_days_update: [null],
        guarantee_days_max_update: [null],
        // is_manufacturer: [null],
        type_guarantee_day: ['months'],
        type_guarantee_day_max: ['months'],
        count_child: [null],
        name_child: [null],
        is_log_blockchain: [true],
        active_buy_online: [null],
        require_activation: [true],
        ...defaultReminderGroup
      });
    }

    this.formTab2 = this.fb.group({ ...defaultReminderGroup });
  }

  parseReminderConfig(rawConfig: any) {
    if (!rawConfig) return null;
    let config = rawConfig.data ? rawConfig.data : rawConfig;
    
    let is_maintenance_reminder = config.is_maintenance_reminder || false;
    let maintenance_mode = config.maintenance_mode || 'once';
    let maintenance_cycle = config.maintenance_cycle || null;
    let maintenance_cycle_unit = config.maintenance_cycle_unit || 'months';
    let is_extend_maintenance = config.is_extend_maintenance || false;
    let extend_limit = config.extend_limit || null;

    if (config.reminderMaintain) {
      is_maintenance_reminder = config.reminderMaintain.isSelect || false;
      maintenance_mode = (config.reminderMaintain.mode === 'REPEAT' || config.reminderMaintain.mode === 'recurring') ? 'recurring' : 'once';
      maintenance_cycle = config.reminderMaintain.numberTimeNotify || null;
      const tType = config.reminderMaintain.timeType;
      maintenance_cycle_unit = tType === 'DAY' ? 'days' : (tType === 'YEAR' ? 'years' : 'months');
      is_extend_maintenance = config.reminderMaintain.reminderContinue || false;
      extend_limit = config.reminderMaintain.numberOfLimit || null;
    }

    let is_expired_reminder = config.is_expired_reminder || false;
    let expired_mode = config.expired_mode || 'once';
    let expired_cycle = config.expired_cycle || null;
    let expired_cycle_unit = config.expired_cycle_unit || 'months';

    if (config.reminderExpired) {
      is_expired_reminder = config.reminderExpired.isSelect || false;
      expired_mode = (config.reminderExpired.mode === 'REPEAT' || config.reminderExpired.mode === 'recurring') ? 'recurring' : 'once';
      expired_cycle = config.reminderExpired.numberTimeNotify || null;
      const tType = config.reminderExpired.timeType;
      expired_cycle_unit = tType === 'DAY' ? 'days' : (tType === 'YEAR' ? 'years' : 'months');
    }

    return {
      is_maintenance_reminder,
      is_extend_maintenance,
      maintenance_mode,
      maintenance_cycle,
      maintenance_cycle_unit,
      extend_limit,
      is_expired_reminder,
      expired_mode,
      expired_cycle,
      expired_cycle_unit
    };
  }

  fillReminderConfigTab1() {
    if (!this.cachedReminderConfig || !this.FormActiveStamp) return;
    const parsed = this.parseReminderConfig(this.cachedReminderConfig);
    if (parsed) {
      this.FormActiveStamp.patchValue(parsed);
    }
  }

  fillReminderConfigTab2() {
    if (!this.cachedReminderConfig || !this.formTab2) return;
    const parsed = this.parseReminderConfig(this.cachedReminderConfig);
    if (parsed) {
      this.formTab2.patchValue(parsed);
    }
  }

  clearReminderConfigForm(form: FormGroup, preserveOverride: boolean = false) {
    if (!form) return;
    const patchData: any = {
      is_maintenance_reminder: false,
      is_extend_maintenance: false,
      maintenance_mode: 'once',
      maintenance_cycle: null,
      maintenance_cycle_unit: 'months',
      extend_limit: null,
      is_expired_reminder: false,
      expired_mode: 'once',
      expired_cycle: null,
      expired_cycle_unit: 'months',
    };
    if (!preserveOverride) {
      patchData.is_override_reminder = false;
    }
    form.patchValue(patchData, { emitEvent: false });
  }

  onOverrideChangeTab1(isOverride: boolean) {
    this.is_override_warranty_tab1 = isOverride;
    if (isOverride) {
      if (this.cachedReminderConfig) {
        this.fillReminderConfigTab1();
      } else if (this.productId) {
        this.fetchAndFillReminderConfig();
      }
    } else {
      this.clearReminderConfigForm(this.FormActiveStamp);
    }
  }

  onOverrideChangeTab2(isOverride: boolean) {
    this.is_override_warranty_tab2 = isOverride;
    if (isOverride) {
      if (this.cachedReminderConfig) {
        this.fillReminderConfigTab2();
      } else if (this.productId) {
        this.fetchAndFillReminderConfig();
      }
    } else {
      this.clearReminderConfigForm(this.formTab2);
    }
  }

  fetchAndFillReminderConfig() {
    if (!this.productId) return;
    this.productService.getProductWarrantyReminderConfig(this.productId).subscribe(
      (res: any) => {
        if (res && (res.data || res.isSelect !== undefined || res.is_maintenance_reminder !== undefined || res.reminderMaintain)) {
          this.cachedReminderConfig = res.data ? res.data : res;
        } else {
          this.cachedReminderConfig = null;
        }
        
        if (this.is_override_warranty_tab1) {
          if (this.cachedReminderConfig) this.fillReminderConfigTab1();
          else this.clearReminderConfigForm(this.FormActiveStamp, true);
        }
        if (this.is_override_warranty_tab2) {
          if (this.cachedReminderConfig) this.fillReminderConfigTab2();
          else this.clearReminderConfigForm(this.formTab2, true);
        }
      },
      () => {
        this.productService.getDetaiById(this.productId).subscribe((res: any) => {
          if (res && !res.error && res.data) {
            const prod = res.data;
            this.FormActiveStamp.patchValue({
              guarantee_days_update: prod.guarantee_days_update,
              type_guarantee_day: prod.type_guarantee_day || 'months',
              guarantee_days_max_update: prod.guarantee_days_max_update,
              type_guarantee_day_max: prod.type_guarantee_day_max || 'months',
              require_activation: prod.is_guarantee_active !== undefined ? prod.is_guarantee_active : true,
            });
            this.cachedReminderConfig = prod;
            
            if (this.is_override_warranty_tab1) {
              if (this.cachedReminderConfig) this.fillReminderConfigTab1();
              else this.clearReminderConfigForm(this.FormActiveStamp, true);
            }
            if (this.is_override_warranty_tab2) {
              if (this.cachedReminderConfig) this.fillReminderConfigTab2();
              else this.clearReminderConfigForm(this.formTab2, true);
            }
          }
        });
      }
    );
  }

  changeProductNew(event) {
    this.productId = event ? event : null;
    if (this.productId) {
      this.fetchAndFillReminderConfig();
    } else {
      this.cachedReminderConfig = null;
      this.is_override_warranty_tab1 = false;
      this.is_override_warranty_tab2 = false;
      this.clearReminderConfigForm(this.FormActiveStamp);
      this.clearReminderConfigForm(this.formTab2);
    }
  }

  get maxActivationDate(): string {
    const produceDate = this.selectedStartDate;
    const maxVal = this.FormActiveStamp.get('guarantee_days_max_update').value;
    const maxType = this.FormActiveStamp.get('type_guarantee_day_max').value;

    if (!produceDate || !maxVal) {
      return '';
    }

    const date = moment(produceDate);
    if (!date.isValid()) {
      return '';
    }

    let unit: moment.unitOfTime.DurationConstructor = 'months';
    if (maxType === 'days') {
      unit = 'days';
    } else if (maxType === 'years') {
      unit = 'years';
    }

    return date.clone().add(Number(maxVal), unit).format('DD/MM/YYYY');
  }

  submitActiveStamp(data) {
    if (this.is_override_warranty_tab1 && data.maintenance_mode === 'recurring' && data.is_extend_maintenance) {
      if (!data.extend_limit || parseInt(data.extend_limit) <= 0) {
        this.toastr.warning('Vui lòng nhập giới hạn số lần gửi sau khi hết hạn BH lớn hơn 0', 'Cảnh báo:', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return;
      }
    }
    
    console.log('kich hoa phai ko', data);
    this.is_loading = true;
    const request: any = {};
    if (this.productId) {
      request.product_id = this.productId;
    }

    request.active_buy_online = data.active_buy_online || false;
    request.is_log_blockchain = data.is_log_blockchain || false;
    request.enableBlockchain = data.is_log_blockchain || false;
    request.require_activation = data.require_activation !== undefined ? data.require_activation : true;

    if (this.nameActionTab1) {
      request.name = this.nameActionTab1;
    }
    if (this.noteTab1) {
      request.note = this.noteTab1;
    }
    if (this.listImageTab1 && this.listImageTab1.length > 0) {
      request.document = {
        items: this.listImageTab1
      };
    }
    // else {
    //   request.is_manufacturer = data.is_manufacturer.length ? data.is_manufacturer : "1";
    // }

    if (data.produce_time) {
      request.produce_time = moment(data.produce_time).format('DD-MM-YYYY');
    }
    if (
      data.guarantee_days_update &&
      parseInt(data.guarantee_days_update) >= 0
    ) {
      request.guarantee_days_update = data.guarantee_days_update;
      // if (data.type_guarantee_day == "d") {
      //   request.guarantee_days = data.guarantee_days;
      // } else if (data.type_guarantee_day == "y") {
      //   request.guarantee_days = parseInt(data.guarantee_days) * 365;
      // } else {
      //   request.guarantee_days = parseInt(data.guarantee_days) * 31;
      // }
    } else {
      // request.guarantee_days_update = 0;
      request.guarantee_days_update = null;
    }
    if (
      data.guarantee_days_max_update &&
      parseInt(data.guarantee_days_max_update) >= 0
    ) {
      request.guarantee_days_max_update = data.guarantee_days_max_update;
      // if (data.type_guarantee_day_max == "days") {
      //   request.guarantee_days_max = parseInt(data.guarantee_days_max);
      // } else if (data.type_guarantee_day_max == "years") {
      //   request.guarantee_days_max = parseInt(data.guarantee_days_max) * 365;
      // } else {
      //   request.guarantee_days_max = parseInt(data.guarantee_days_max) * 31;
      // }
    } else {
      // request.guarantee_days_max_update = 0;
      request.guarantee_days_max_update = null;
    }

    if (data.count_child) {
      request.count_child = data.count_child;
    } else if (this.batch_detail.has_child) {
      // nếu ko nhập count_child mà trong khi lô đã từng tách thì ntn
      request.count_child = this.batch_detail.active_left;
    }
    if (data.name_child) {
      request.name_child = data.name_child;
    }

    if (this.batch_product_number) {
      request.batch_product_number = this.batch_product_number;
    }
    //gan kieu d/m/y cua thoi gian bao hanh vao truong request
    request.type_guarantee_day = data.type_guarantee_day;
    request.type_guarantee_day_max = data.type_guarantee_day_max;

    if (this.is_override_warranty_tab1) {
      request.is_override = true;
      request.warrantyReminderConfig = {};
      
      if (data.is_maintenance_reminder) {
        request.warrantyReminderConfig.reminderMaintain = {
          isSelect: true,
          mode: data.maintenance_mode === 'once' ? 'ONCE' : 'REPEAT',
          reminderContinue: data.is_extend_maintenance || false,
          numberTimeNotify: parseInt(data.maintenance_cycle) || 0,
          timeType: data.maintenance_cycle_unit === 'days' ? 'DAY' : (data.maintenance_cycle_unit === 'months' ? 'MONTH' : 'YEAR'),
          numberOfLimit: data.maintenance_mode === 'once' ? undefined : ((data.is_extend_maintenance && data.extend_limit) ? parseInt(data.extend_limit) : 0)
        };
      } else {
        request.warrantyReminderConfig.reminderMaintain = {
          isSelect: false,
          mode: 'ONCE',
          reminderContinue: false,
          numberTimeNotify: 0,
          timeType: 'DAY',
          numberOfLimit: undefined
        };
      }

      if (data.is_expired_reminder) {
        request.warrantyReminderConfig.reminderExpired = {
          isSelect: true,
          mode: data.expired_mode === 'once' ? 'ONCE' : 'REPEAT',
          reminderContinue: false,
          numberTimeNotify: parseInt(data.expired_cycle) || 0,
          timeType: data.expired_cycle_unit === 'days' ? 'DAY' : (data.expired_cycle_unit === 'months' ? 'MONTH' : 'YEAR'),
          numberOfLimit: data.expired_mode === 'once' ? undefined : 1
        };
      } else {
        request.warrantyReminderConfig.reminderExpired = {
          isSelect: false,
          mode: 'ONCE',
          reminderContinue: false,
          numberTimeNotify: 0,
          timeType: 'DAY',
          numberOfLimit: undefined
        };
      }
    }

    this.batchService
      .activeForPrint(this.batch_detail.id, request)
      .toPromise()
      .then((res: any) => {
        this.is_loading = false;
        if (res.code === 1) {
          clickTracking(
            'qcheck_batch_detail',
            'active_submit',
            'qcheck_batch_manage',
            ''
          );
          this.createForm();
          let mess: any;
          if (
            !request.count_child ||
            this.active_left - request.count_child == 0
          ) {
            // this.bsModalRef.hide();
            mess = res.message ? res.message : this.translate.instant('KICH_HOAT_LO_THANH_CONG');
          } else {
            this.active_left = this.active_left - request.count_child;
            mess = res.message
              ? res.message
              : this.translate.instant('TAO_KICH_HOAT_LO_CAP_2_THANH_CONG');
          }

          this.toastr.success(this.translate.instant('KICH_HOAT_THANH_CONG'), this.translate.instant('THANH_CONG'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
          this.hideCrating.emit({ updated: true });
        } else {
          console.log('error:false', res.message);
          const mess = res.message
            ? res.message
            : this.translate.instant('THAO_TAC_THANH_CONG_VUI_LONG_THU_LAI');
          this.toastr.warning(mess, this.translate.instant('CANH_BAO'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        }
      })
      .catch((err: any) => {
        this.is_loading = false;
        console.log('catch:', err);
        const mess = err.message
          ? err.message
          : this.translate.instant('THAO_TAC_THANH_CONG_VUI_LONG_THU_LAI');
        this.toastr.warning(mess, this.translate.instant('CANH_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      });
  }

  backToList(data = {}) {
    this.hideCrating.emit(data);
  }

  /** Tuanba 13/04: Meskong gas */
  public selectedStartDate: any;

  /** Xử lý phần kích hoạt lô tem - tách lô và kích hoạt*/
  updateMyDate(newDate) {
    if (this.source === 2) {
      console.log('newDate', newDate);
      if (newDate !== undefined) {
        if (newDate === null) {
          this.batch_product_number =
            this.batch_detail.batch_order_code.slice(-9);
        } else {
          const formatDate = moment(newDate).format('DD-MM');
          const batch_product_number =
            this.batch_detail.batch_order_code.slice(-9) +
            '-' +
            formatDate.replace('-', '');
          this.FormActiveStamp.get('batch_product_number').setValue(
            batch_product_number
          );
          this.batch_product_number = batch_product_number;
        }
      }
    }
  }

  updateMyDate2(newDate) {
    if (this.source === 2) {
      console.log('newDate', newDate);
      if (this.activeTab === 1) {
        if (newDate !== undefined) {
          if (newDate === null) {
            this.batch_product_number_2 = this.batch_product_number_2;
          } else {
            const formatDate = moment(newDate).format('DD-MM');
            if (this.batch_product_number_2.length === 9) {
              this.batch_product_number_2 = this.batch_product_number_2 + '-' + formatDate.replace('-', '');
            } else {
              this.batch_product_number_2 = this.batch_product_number_2.slice(0, -5) + '-' + formatDate.replace('-', '');
            }
            this.listItemTab2.map((res) => {
              if (res.batchOrderCode || res.batchOrderCode !== '') {
                res.batchProductNumber = res.batchOrderCode.slice(-9) + '-' + formatDate.replace('-', '');
              }
            });
            console.log('thissss2222', this.listItemTab2);
          }
        }
      } else {
        console.log('newdate3333', this.listItemTab2);
        if (newDate !== undefined) {
          if (newDate === null) {
            this.produce_time = null;
            console.log(' this.batch_product_number_3', this.batch_product_number_3);
            this.batch_product_number_3 = this.batch_product_number_3;

          } else {
            console.log('typeof2', typeof newDate);
            const formatDate = moment(newDate).format('DD-MM');
            if (this.batch_product_number_3.length === 9) {
              this.batch_product_number_3 = this.batch_product_number_3 + '-' + formatDate.replace('-', '');
            } else {
              this.batch_product_number_3 = this.batch_product_number_3.slice(0, -5) + '-' + formatDate.replace('-', '');
            }
            // this.batch_order_code_2 = this.batch_product_number_3
            // this.listItemTab2.map((res) => {
            //   if (res.batchProductNumber !== "") {
            //     res.batchProductNumber = res.batchProductNumber.slice(0, -5) + "-" + formatDate.replace("-", "");
            //   } else {
            //     console.log(123123);
            //   }
            // });
            console.log('ra cái gì ???', this.listItemTab2);
          }
        }
      }
    }
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  public isExcel: Boolean = false;

  submitFormImportExcel() {
    console.log('uploadFileExcel', this.uploadExcel)
    this.message = null;
    this.data_import_success = null;
    this.data_import_fail = null
    this.titleFile = this.translate.instant('CHON_FILE_UPLOAD');
    console.log('this.files ', this.files)
    if (this.files !== null && this.files.length > 0) {
      const file = this.files[0];
      this.files = null;
      // tslint:disable-next-line:prefer-const
      const file_name = file.name;
      let allowedExtensions = ['xlsx', 'xls', 'csv'];
      let fileExtension = file_name.split('.').pop();
      console.log('allowedExtensions', allowedExtensions)
      console.log('fileExtension', fileExtension)
      if (this.isInArray(allowedExtensions, fileExtension)) {
        this.isExcel = true;
        console.log('isExcel', this.isExcel)
        //msg process
        this.message = {
          class: 'alert dark alert-success',
          content: this.translate.instant('SS_DANG_THUC_HIEN')
        };
        //upload file
        // this.storeSaleService.uploadFileProduct(file).subscribe((res: any) => {
        //   if (res.code === 1) {
        //
        //     // this.data_import_success = {
        //     //   class: "alert dark alert-icon alert-success",
        //     //   content: 'Số sản phẩm import thành công: ' + res.data.success,
        //     // }
        //
        //     // this.data_import_fail = {
        //     //   class: "alert dark alert-icon alert-warning",
        //     //   content: 'Số sản phẩm import không thành công: ' + res.data.fail,
        //     // }
        //
        //     this.message = {
        //       class: "alert dark alert-icon alert-success",
        //       content: 'Import sản phẩm thành công !!',
        //     };
        //     setTimeout(() => {
        //       this.pageIndex = 1;
        //       this.loadData();
        //     }, 1000);
        //   } else {
        //     this.message = {
        //       class: "alert dark alert-icon alert-danger",
        //       content: res.message
        //     }
        //     ;
        //   }
        // }, error => {
        //   this.message = {
        //     class: "alert dark alert-icon alert-danger",
        //     content: error.message
        //   };
        // });
      } else {
        this.message = {
          class: 'alert alert-danger',
          content: this.translate.instant('VUI_LONG_CHON_DUNG_FILE_EXCEL')
        };
      }
    } else {
      this.isExcel = false;
      this.message = {
        class: 'alert alert-danger',
        content: this.translate.instant('BAN_CHUA_CHON_FILE_DE_IMPORT')
      };
    }
    this.clearInputFile()
  }

  // submitForm(f) {
  //   if (this.myform.valid) {
  //     console.log("Form Submitted!");
  //   }
  // }

  clearInputFile() {
    $('#uploadForm').get(0).reset()
    this.titleFile = 'Chọn file upload';
    this.activeUpload = 0;
    this.uploadExcel = {};
    const input = $('#controlFile');
    input.wrap('<form>').closest('form').get(0).reset();
    input.unwrap();
  }

  onChange(event) {
    this.files = event.target.files;
    if (this.files.length > 0) {
      this.titleFile = this.files[0].name;
    } else {
      this.titleFile = 'Chọn file upload';
    }
  }


  uploadFileNumber(file) {
    const fileData = new FormData();
    fileData.append('file', file);
    this.upload.uploadImagesNew2(fileData).subscribe((resUpload: any) => {
      const parsedRes = JSON.parse(resUpload._body);
      if (parsedRes.status === 200) {
        const fileUrl = parsedRes.data.url;
        const body: any = {
          file: fileUrl,
          batchId: this.batch_detail.id,
          enableBlockchain: this.is_log_blockchain_tab3,
          name: this.nameActionExcel,
          note: this.noteExcel,
          document: {
            items: this.listImageExcel
          }
        };

        this.activeTempNewService.uploadFileNumberProduct(body).subscribe((res: any) => {
          if (res.code == 1) {
            this.errMsgAlertBoxStamp = this.translate.instant('HE_THONG_DANG_XU_LY_KICH_HOAT');
            this.hideCrating.emit({ updated: true, alert: 1, errMsg: this.errMsgAlertBoxStamp });
          } else {
            this.toastr.error(res.message, this.translate.instant('THAT_BAI'), {
              positionClass: 'toast-bottom-right',
            });
          }
        }, (error) => {
          this.toastr.error(error.message, this.translate.instant('THAT_BAI'), {
            positionClass: 'toast-bottom-right',
          });
        });
      } else {
        this.toastr.error(parsedRes.message, this.translate.instant('THAT_BAI'));
      }
      this.clearInputFile();
      this.isFormSubmitted = false;
    }, (error) => {
      this.toastr.error(this.translate.instant('LOI_TAI_FILE_CDN'), this.translate.instant('THAT_BAI'));
      this.clearInputFile();
      this.isFormSubmitted = false;
    });
  }

  uploadFileBatchSerial(type?: any) {
    const file = this.files[0];
    const fileData = new FormData();
    fileData.append('file', file);
    this.upload.uploadImagesNew2(fileData).subscribe((resUpload: any) => {
      const parsedRes = JSON.parse(resUpload._body);
      if (parsedRes.status === 200) {
        const fileUrl = parsedRes.data.url;
        const body: any = {
          file: fileUrl,
          type: type,
          enableBlockchain: this.is_log_blockchain_tab3,
          name: this.nameActionExcel,
          note: this.noteExcel,
          document: {
            items: this.listImageExcel
          }
        };

        this.activeTempNewService.uploadFileBatchSerial(body).subscribe((res: any) => {
          if (res.code == 1) {
            this.errMsgAlertBoxStamp = this.translate.instant('HE_THONG_DANG_XU_LY_KICH_HOAT');
            this.hideCrating.emit({ updated: true, alert: 1, errMsg: this.errMsgAlertBoxStamp });
          } else {
            this.closeConfirmUpLoad();
            this.toastr.error(res.message, this.translate.instant('THAT_BAI'), {
              positionClass: 'toast-bottom-right',
            });
          }
        }, (error) => {
          this.closeConfirmUpLoad();
          this.toastr.error(error.message, this.translate.instant('THAT_BAI'), {
            positionClass: 'toast-bottom-right',
          });
        });
      } else {
        this.toastr.error(parsedRes.message, this.translate.instant('THAT_BAI'));
      }
      this.clearInputFile();
      this.isFormSubmitted = false;
    }, (error) => {
      this.toastr.error(this.translate.instant('LOI_TAI_FILE_CDN'), this.translate.instant('THAT_BAI'));
      this.clearInputFile();
      this.isFormSubmitted = false;
    });
  }

  validateImport() {
    this.isFormSubmitted = true;
    if (Object.keys(this.uploadExcel).length === 0) {
      console.log('this.uploadExcel', this.uploadExcel)
    } else {
      console.log('this.uploadExcel2222', this.uploadExcel)
      if (this.files !== null && this.files.length > 0) {
        const file = this.files[0];
        // tslint:disable-next-line:prefer-const
        const file_name = file.name;
        const allowedExtensions = ['xlsx', 'xls', 'csv'];
        const fileExtension = file_name.split('.').pop();
        console.log('allowedExtensions', allowedExtensions)
        console.log('fileExtension', fileExtension)
        if (this.isInArray(allowedExtensions, fileExtension)) {
          console.log('in', allowedExtensions)
          if (this.uploadExcel.type == 1) {
            this.uploadFileNumber(file)
          } else if (this.uploadExcel.type == 2) {
            this.showConfirmUpLoad();
          }
          this.isExcel = false;
        } else {
          this.isExcel = true;
        }
      } else {
        console.log(123123123)
      }
    }
  }

  showConfirmUpLoad() {
    this.confirmUpload.show();
  }

  closeConfirmUpLoad() {
    this.confirmUpload.hide()
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/share/ActiveTempNew/ActiveTempNew.ts